webpackJsonp([296],{

/***/ 1059:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.3.8 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1874:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1059),
  /* template */
  __webpack_require__(2314),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.3.8-236.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.3.8-236.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c4e4e9b", Component.options)
  } else {
    hotAPI.reload("data-v-6c4e4e9b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2314:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.3.8 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 当前选中 item 被 disabled 时清除值 #1479")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:disabled 禁用操作 #1254")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 不可见日期不可点击 #1564")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 iOS 低版本下 placeholder 无法显示的问题 #1293")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/radio.html"
    }
  }, [_vm._v("Radio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:disabled 禁用操作 #1254")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 less 变量 @radio-checked-icon-color #896")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 slot:title，方便自定义样式 #1389")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 是的，Datetime 可以作为插件直接调用了")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6c4e4e9b", module.exports)
  }
}

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1874);

/***/ })

});


// WEBPACK FOOTER //
// 296.5737b951.js